var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPremiumBrandEinbruchschutz = function SvgPremiumBrandEinbruchschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.87,
    height: 88.988
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brand-einbruchschutz_svg__e",
    x1: 22.578,
    x2: 21.203,
    y1: 83.121,
    y2: 6.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#f17011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#f79f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#fbc15f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#fed673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brand-einbruchschutz_svg__f",
    x1: 29.236,
    x2: 12.493,
    y1: 76.209,
    y2: 14.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#f3811d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fed564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brand-einbruchschutz_svg__i",
    x1: 42.241,
    x2: 30.142,
    y1: 48.21,
    y2: 60.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59797f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0b2b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brand-einbruchschutz_svg__j",
    x1: 34.92,
    x2: 28.038,
    y1: 42.712,
    y2: 61.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brand-einbruchschutz_svg__a",
    x1: 29.242,
    x2: 43.54,
    y1: 49.72,
    y2: 59.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f4f8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__a",
    id: "premium-brand-einbruchschutz_svg__k",
    x1: 32.065,
    x2: 39.848,
    y1: 45.21,
    y2: 51.351
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brand-einbruchschutz_svg__b",
    x1: 6.919,
    x2: 15.664,
    y1: 45.513,
    y2: 46.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__b",
    id: "premium-brand-einbruchschutz_svg__l",
    x1: 54.957,
    x2: 60.307,
    y1: 53.862,
    y2: 54.646
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__b",
    id: "premium-brand-einbruchschutz_svg__m",
    x1: 26.317,
    x2: 44.105,
    y1: 47.236,
    y2: 49.842
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__b",
    id: "premium-brand-einbruchschutz_svg__n",
    x1: 12.311,
    x2: 29.268,
    y1: 45.581,
    y2: 48.066
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__b",
    id: "premium-brand-einbruchschutz_svg__o",
    x1: 39.643,
    x2: 54.186,
    y1: 50.578,
    y2: 52.708
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brand-einbruchschutz_svg__p",
    x1: 41.889,
    x2: 34.005,
    y1: 84.402,
    y2: 23.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#ef6001",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#f48b2b",
    stopOpacity: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#fab856",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#fed370",
    stopOpacity: 0.132
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__e",
    id: "premium-brand-einbruchschutz_svg__r",
    x1: 47.477,
    x2: 46.217,
    y1: 82.922,
    y2: 12.337
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__f",
    id: "premium-brand-einbruchschutz_svg__s",
    x1: 45.672,
    x2: 55.252,
    y1: 74.252,
    y2: 3.667
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brand-einbruchschutz_svg__t",
    x1: 45.27,
    x2: 49.266,
    y1: 86.466,
    y2: 30.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brand-einbruchschutz_svg__g",
    x1: 36.699,
    x2: 33.919,
    y1: 87.913,
    y2: 59.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcefb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9dc5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__g",
    id: "premium-brand-einbruchschutz_svg__u",
    x1: 1.154,
    x2: 68.716,
    y1: 72.466,
    y2: 72.466
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brand-einbruchschutz_svg__h",
    x1: 21.019,
    x2: 27.185,
    y1: 73.969,
    y2: 68.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fae588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9dc5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__b",
    id: "premium-brand-einbruchschutz_svg__v",
    x1: 26.448,
    x2: 20.137,
    y1: 71.801,
    y2: 69.551
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__h",
    id: "premium-brand-einbruchschutz_svg__w",
    x1: 31.841,
    x2: 38.007,
    y1: 73.969,
    y2: 68.714
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__b",
    id: "premium-brand-einbruchschutz_svg__x",
    x1: 37.271,
    x2: 30.959,
    y1: 71.801,
    y2: 69.551
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__h",
    id: "premium-brand-einbruchschutz_svg__y",
    x1: 42.664,
    x2: 48.83,
    y1: 73.969,
    y2: 68.714
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brand-einbruchschutz_svg__b",
    id: "premium-brand-einbruchschutz_svg__z",
    x1: 48.093,
    x2: 41.782,
    y1: 71.801,
    y2: 69.551
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "premium-brand-einbruchschutz_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M60.732 37.522s3.359 20.14-6.354 24.492c3.6-9.155 2.404-24.704-5.769-36.658C37.557 10.928 40.322 0 40.322 0c-.176.108-.352.22-.524.327-3.301 2.573-11.282 10.766-3.045 25.316 3.68 6.498 4.851 12.342 4.355 17.615-.75 7.99-5.334 14.671-10.833 20.336-.077.08-.143.165-.218.245-.34.361-.672.727-.981 1.105-.147.18-.277.37-.418.555-.221.29-.446.578-.65.877-.144.211-.272.429-.407.644-.178.282-.358.562-.521.85-.13.23-.245.464-.365.697-.145.281-.29.561-.422.846-.111.243-.21.49-.31.735-.116.282-.232.563-.334.848-.091.253-.17.507-.251.762a20 20 0 0 0-.25.845q-.102.392-.187.785-.095.419-.168.838-.07.399-.122.799-.054.414-.089.826-.035.404-.052.807-.015.408-.012.812c.002.27.005.538.02.805.013.267.038.531.065.796.026.266.052.532.091.796.039.26.091.516.142.773.052.262.101.524.166.782.064.252.144.498.22.747.077.253.15.509.24.758.09.246.2.485.302.726.102.24.196.483.31.718.123.248.267.485.403.727.122.215.232.436.365.645a15 15 0 0 0 2.042 2.518 47.5 47.5 0 0 0 7.2.72c7.893.202 15.658-3.302 21.748-8.744 12.534-11.195 17.983-30.585 2.9-42.715"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "premium-brand-einbruchschutz_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.518-5H74.87v98.989H19.518z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "premium-brand-einbruchschutz_svg__q",
    width: 55.68,
    height: 99.84,
    x: 19.42,
    y: -5.415,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#premium-brand-einbruchschutz_svg__c)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#premium-brand-einbruchschutz_svg__d)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAADQCAYAAADWF0XfAAAACXBIWXMAABcRAAAXEQHKJvM/AAAB8klEQVR4Xu3RMREAIBDAMMC/50cCM71k7tY9M7PIOK+AvxgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2jMBSvkBZwnP0WmAAAAAElFTkSuQmCC",
    width: 116,
    height: 208,
    transform: "matrix(.48 0 0 .48 19.42 -5.415)"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__e)",
    d: "M31.984 61.53c-7.661 7.893-8.534 20.073-1.518 26.912C8.846 84.564-3.323 66.852.796 40.886c1.797 7.193 1.399 11.587 10.787 20.375-6.865-13.557-14.666-33.637 16.56-58.73-1.953 4.7-4.192 14.272 4.515 22.979a98.5 98.5 0 0 1 11.145 13.833c-.818 8.718-5.82 16.007-11.82 22.187"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__f)",
    d: "M31.985 61.53c-6.918 7.629-8.393 18.537-2.762 25.542C10.413 83.076.068 68.281 1.191 47.534c1.138 4.29 3.068 8.386 9.635 14.533a1.1 1.1 0 0 0 .759.299 1.105 1.105 0 0 0 .983-1.602c-3.665-7.241-6.917-15.208-5.893-24.42 1.05-9.434 4.72-15.872 13.252-24.547a1.438 1.438 0 0 1 2.448.853c.542 4.057 4.273 7.605 9.5 13.64 3.333 3.848 10.374 10.658 10.85 15.173.167 1.589-.752 9.053-10.74 20.067"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M35.686 88.706s13.448-11.378 18.261-17.074c6.87-8.122 10.291-32.707 8.289-43.138l-26.55-7.277-26.55 7.285c-2.002 10.423 1.42 35.008 8.289 43.13 4.814 5.696 18.261 17.074 18.261 17.074"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "M35.228 82.234c-4.05-3.549-11.293-10.03-14.288-13.564-4.954-5.858-8.42-25.034-7.678-36.041l.034-.493 22.39-6.146 22.39 6.138.034.493c.742 11.005-2.724 30.18-7.677 36.038-3.198 3.784-11.059 10.755-14.29 13.576l-.458.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M35.686 81.712c-4.62-4.047-11.362-10.123-14.216-13.49-4.857-5.745-8.235-24.859-7.515-35.546l21.731-5.966 21.731 5.958c.72 10.687-2.66 29.8-7.514 35.542-2.858 3.381-9.598 9.468-14.217 13.502"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__i)",
    d: "M43.986 50.547h-1.443v-3.103a6.86 6.86 0 0 0-13.714 0v3.103h-1.442a1.24 1.24 0 0 0-1.242 1.24v10.158a1.24 1.24 0 0 0 1.242 1.241h16.599a1.24 1.24 0 0 0 1.241-1.24v-10.16a1.24 1.24 0 0 0-1.241-1.239m-3.732 0h-9.136v-3.103a4.574 4.574 0 0 1 9.136 0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__j)",
    d: "M27.13 62.704V52.546a1.24 1.24 0 0 1 1.24-1.24h1.443v-3.103a6.753 6.753 0 0 1 6.858-6.626 7 7 0 0 1 3.758 1.088 6.96 6.96 0 0 0-4.742-1.848 6.753 6.753 0 0 0-6.858 6.627v3.103h-1.442a1.24 1.24 0 0 0-1.242 1.24v10.158a1.24 1.24 0 0 0 1.077 1.23 1.2 1.2 0 0 1-.093-.47"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__a)",
    d: "M35.686 41.196a6.37 6.37 0 0 1 6.477 6.248v3.482h1.822a.863.863 0 0 1 .862.861v10.158a.863.863 0 0 1-.862.861H27.387a.863.863 0 0 1-.861-.861V51.787a.863.863 0 0 1 .861-.861h1.823v-3.482a6.37 6.37 0 0 1 6.476-6.248m0-.38a6.75 6.75 0 0 0-6.856 6.628v3.102h-1.443a1.24 1.24 0 0 0-1.24 1.241v10.158a1.24 1.24 0 0 0 1.24 1.241h16.598a1.24 1.24 0 0 0 1.241-1.241V51.787a1.24 1.24 0 0 0-1.241-1.24h-1.443v-3.103a6.75 6.75 0 0 0-6.856-6.628"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__k)",
    d: "M35.687 43.105a4.46 4.46 0 0 1 4.567 4.339v3.103h-9.136v-3.103a4.463 4.463 0 0 1 4.57-4.34m0-.347a4.81 4.81 0 0 0-4.917 4.687v3.45h9.83v-3.45a4.81 4.81 0 0 0-4.914-4.687"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__b)",
    d: "M13.175 36.997c-1.735-.421-3.29-.81-4.604-1.145a94 94 0 0 0 2.41 20.158q2.294-.667 4.479-1.144a91.6 91.6 0 0 1-2.285-17.869",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__l)",
    d: "M57.686 44.4a83 83 0 0 1-3.742 17.367 43 43 0 0 1 3.763 3.076 81.9 81.9 0 0 0 4.62-20.48 59 59 0 0 1-4.641.037",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m21.612 69.434-.115-.128c-.197-.22-.387-.435-.557-.636-4.954-5.858-8.42-25.034-7.678-36.041l.034-.493 21.416-5.88-21.554 5.378-.357.098-.025.37-.033.492c-.749 11.1 2.773 30.469 7.799 36.413a52 52 0 0 0 4.625 4.056c-1.362-1.318-2.595-2.567-3.555-3.63"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__m)",
    d: "M44.704 50.779a1.23 1.23 0 0 0-.719-.233h-1.442v-3.102a6.4 6.4 0 0 0-1.035-3.47 317 317 0 0 1-10.03-1.74 6.7 6.7 0 0 0-1.402 1.411 6.43 6.43 0 0 0-1.247 3.799v3.102h-1.442a1.24 1.24 0 0 0-1.242 1.24v.672a51 51 0 0 1 1.608-.028 45.7 45.7 0 0 1 17.474 3.334v-3.978a1.24 1.24 0 0 0-.523-1.007m-4.45-.232h-9.136v-3.103a4.14 4.14 0 0 1 .553-2.067 4.46 4.46 0 0 1 1.464-1.53 4.7 4.7 0 0 1 .776-.401 4.8 4.8 0 0 1 3.552 0 4.6 4.6 0 0 1 .776.4 4.46 4.46 0 0 1 1.463 1.53 4.14 4.14 0 0 1 .552 2.068Z",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__n)",
    d: "M26.145 51.786a1.24 1.24 0 0 1 1.242-1.24h1.442v-3.102a6.43 6.43 0 0 1 1.247-3.799 6.8 6.8 0 0 1 2.002-1.819c-6.764-1.287-13.187-2.738-18.18-3.94a93 93 0 0 0 2.091 16.162 59 59 0 0 1 10.156-1.243Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__o)",
    d: "M41.09 43.39c.111.138.224.275.325.422a6.43 6.43 0 0 1 1.128 3.632v3.102h1.442a1.25 1.25 0 0 1 1.242 1.24v4.325a43.3 43.3 0 0 1 8.369 4.55A84 84 0 0 0 56.9 45.067a142 142 0 0 1-15.812-1.677",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__p)",
    d: "M57.708 64.842a60 60 0 0 0 2.269-7.137l.001-.006q.324-1.268.613-2.575l.011-.05c.38-1.727.715-3.492 1-5.265l.016-.094q.205-1.283.375-2.565l.03-.223c.934-7.13 1.056-14.039.213-18.433l-26.55-7.277-26.55 7.285a45.7 45.7 0 0 0-.526 9.612l.003.093q.038 1.13.112 2.305l.013.207c.103 1.59.252 3.226.447 4.885l.013.12q.149 1.249.33 2.508l.016.106c.247 1.697.54 3.396.876 5.07l.02.099c1.515 7.512 3.9 14.479 6.985 18.125 4.814 5.696 18.261 17.074 18.261 17.074s13.448-11.378 18.261-17.074a24.9 24.9 0 0 0 3.76-6.789Z",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#premium-brand-einbruchschutz_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__r)",
    d: "M57.832 80.237c-6.09 5.442-13.854 8.946-21.747 8.743a47.5 47.5 0 0 1-7.2-.719c-6.432-6.269-5.632-17.433 1.39-24.667 5.5-5.665 10.084-12.346 10.833-20.336.496-5.273-.675-11.117-4.355-17.615C28.516 11.093 36.497 2.9 39.798.327q.259-.163.524-.327s-2.765 10.928 8.287 25.356c8.173 11.954 9.368 27.503 5.77 36.658 9.712-4.351 6.353-24.492 6.353-24.492 15.083 12.13 9.634 31.52-2.9 42.715"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__s)",
    d: "M57.158 79.48c-6.13 5.48-13.385 8.497-20.423 8.497q-.31 0-.625-.01a46.3 46.3 0 0 1-7.045-.702 40 40 0 0 1-1.32-.26c-5.162-6.42-4.044-16.639 2.532-23.411 5.266-5.425 10.22-11.875 11.839-20.242 1.117-5.776-.956-11.984-4.48-18.21-6.789-11.983-2.17-19.356 1.377-22.793-.202 4.17.622 12.947 8.774 23.6a44 44 0 0 1 7.116 18.919c.827 6.188.29 12.301-1.468 16.774a1.013 1.013 0 0 0 .945 1.384 1 1 0 0 0 .412-.087c8.173-3.663 7.839-17.058 7.275-22.882a21.6 21.6 0 0 1 6.782 15.175c.22 8.45-4.152 17.517-11.69 24.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__t)",
    d: "M37.636 25.143c3.524 6.225 5.597 12.433 4.48 18.209-1.62 8.367-6.573 14.817-11.84 20.242-6.575 6.772-7.693 16.99-2.531 23.41q.652.141 1.32.26a46.3 46.3 0 0 0 7.045.703q.316.01.625.01c7.038 0 14.293-3.018 20.423-8.497 7.539-6.731 11.91-15.799 11.69-24.248 0 0-4.672 17.605-20.31 17.605s-2.011-15.75-.869-21.025c3.649-16.855-10.033-26.67-10.033-26.67",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e03616",
    d: "M25.368 71.802a20.1 20.1 0 0 1 3.516-7.015c.817-1.052 1.76-1.968 2.61-2.947.87-.97 1.701-1.97 2.505-2.99a37 37 0 0 0 7.156-13.612 18.4 18.4 0 0 0 .638-7.575 29.9 29.9 0 0 0-2.053-7.423 46 46 0 0 0-1.617-3.539c-.585-1.153-1.244-2.3-1.785-3.503a23.1 23.1 0 0 1-2.064-7.574 24.6 24.6 0 0 0 2.512 7.359c.58 1.16 1.26 2.263 1.902 3.419a47 47 0 0 1 1.77 3.533 27.7 27.7 0 0 1 2.25 7.612 19.8 19.8 0 0 1 .13 4.01 21.4 21.4 0 0 1-.705 3.941A36.6 36.6 0 0 1 34.6 59.34a62 62 0 0 1-2.639 2.931c-.9.963-1.865 1.846-2.696 2.828a21.1 21.1 0 0 0-3.898 6.703"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__g)",
    d: "M64.463 82.668a86.84 86.84 0 0 0-59.057 0 1.394 1.394 0 0 1-1.78-1.06L.427 70.195a1.726 1.726 0 0 1 .93-2.098 98.32 98.32 0 0 1 67.154 0 1.726 1.726 0 0 1 .93 2.098l-3.198 11.411a1.394 1.394 0 0 1-1.78 1.06"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__u)",
    d: "M64.89 81.82a.6.6 0 0 1-.192-.034 87.53 87.53 0 0 0-59.527 0 .6.6 0 0 1-.193.034.64.64 0 0 1-.595-.499l-3.198-11.41a.85.85 0 0 1 .041-.572.65.65 0 0 1 .367-.359 97.64 97.64 0 0 1 66.683 0 .65.65 0 0 1 .367.36.85.85 0 0 1 .041.571l-3.198 11.411a.64.64 0 0 1-.595.498"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__h)",
    d: "m24.309 66.592 1.144 2.318a.22.22 0 0 0 .165.12l2.558.372a.22.22 0 0 1 .122.374l-1.851 1.804a.22.22 0 0 0-.063.194l.437 2.548a.22.22 0 0 1-.319.231l-2.288-1.202a.22.22 0 0 0-.204 0l-2.288 1.202a.22.22 0 0 1-.318-.23l.437-2.549a.22.22 0 0 0-.063-.194l-1.851-1.804a.22.22 0 0 1 .121-.374l2.558-.372a.22.22 0 0 0 .165-.12l1.144-2.318a.22.22 0 0 1 .394 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__v)",
    d: "M24.112 66.47a.22.22 0 0 1 .197.122l1.144 2.318a.22.22 0 0 0 .165.12l2.558.372a.22.22 0 0 1 .122.374l-1.851 1.804a.22.22 0 0 0-.063.194l.437 2.548a.219.219 0 0 1-.319.231l-2.288-1.202a.22.22 0 0 0-.204 0l-2.288 1.202a.219.219 0 0 1-.318-.23l.437-2.549a.22.22 0 0 0-.063-.194l-1.851-1.804a.22.22 0 0 1 .121-.374l2.558-.372a.22.22 0 0 0 .165-.12l1.144-2.318a.22.22 0 0 1 .197-.122m0-.227a.44.44 0 0 0-.4.249l-1.144 2.318-2.553.367a.447.447 0 0 0-.247.762l1.851 1.804-.44 2.54a.446.446 0 0 0 .649.472l2.288-1.203 2.28 1.203a.447.447 0 0 0 .649-.471l-.437-2.548 1.848-1.797a.447.447 0 0 0-.247-.762l-2.558-.372-1.138-2.314a.44.44 0 0 0-.4-.249",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2c756",
    d: "m21.568 74.543.436-2.548a.22.22 0 0 0-.063-.194l-.106-.104a.2.2 0 0 1 .006.077l-.437 2.548a.215.215 0 0 0 .166.245c0-.009-.004-.015-.003-.024M25.617 69.13a.22.22 0 0 0 .165.12l2.558.372c.007.001.01.007.017.008a.214.214 0 0 0-.18-.228l-2.559-.372a.2.2 0 0 1-.064-.026ZM20.212 69.622l2.558-.371a.22.22 0 0 0 .165-.12l1.144-2.318a.216.216 0 0 1 .291-.097l-.061-.124a.22.22 0 0 0-.394 0l-1.144 2.318a.22.22 0 0 1-.165.12l-2.558.372a.22.22 0 0 0-.121.374l.103.1a.22.22 0 0 1 .182-.254"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__w)",
    d: "m35.132 66.592 1.144 2.318a.22.22 0 0 0 .165.12l2.558.372a.22.22 0 0 1 .121.374l-1.85 1.804a.22.22 0 0 0-.064.194l.437 2.548a.22.22 0 0 1-.318.231l-2.288-1.202a.22.22 0 0 0-.204 0l-2.288 1.202a.22.22 0 0 1-.319-.23l.437-2.549a.22.22 0 0 0-.063-.194l-1.85-1.804a.22.22 0 0 1 .12-.374l2.559-.372a.22.22 0 0 0 .165-.12l1.144-2.318a.22.22 0 0 1 .394 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__x)",
    d: "M34.935 66.47a.22.22 0 0 1 .197.122l1.144 2.318a.22.22 0 0 0 .165.12l2.558.372a.22.22 0 0 1 .121.374l-1.85 1.804a.22.22 0 0 0-.064.194l.437 2.548a.219.219 0 0 1-.318.231l-2.288-1.202a.22.22 0 0 0-.204 0l-2.288 1.202a.219.219 0 0 1-.319-.23l.437-2.549a.22.22 0 0 0-.063-.194l-1.85-1.804a.22.22 0 0 1 .12-.374l2.559-.372a.22.22 0 0 0 .165-.12l1.144-2.318a.22.22 0 0 1 .197-.122m0-.228a.44.44 0 0 0-.4.25l-1.145 2.317-2.552.368a.447.447 0 0 0-.247.762l1.85 1.804-.439 2.54a.446.446 0 0 0 .648.472l2.288-1.203 2.281 1.203a.447.447 0 0 0 .648-.471l-.437-2.548 1.849-1.797a.447.447 0 0 0-.248-.762l-2.558-.372-1.138-2.314a.44.44 0 0 0-.4-.249",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2c756",
    d: "m32.39 74.543.437-2.548a.22.22 0 0 0-.063-.194l-.106-.104a.2.2 0 0 1 .005.077l-.437 2.548a.215.215 0 0 0 .167.245c0-.009-.004-.015-.003-.024M36.44 69.13a.22.22 0 0 0 .164.12l2.558.372c.007.001.011.007.018.008a.214.214 0 0 0-.181-.228l-2.558-.372a.2.2 0 0 1-.064-.026ZM31.035 69.622l2.558-.371a.22.22 0 0 0 .165-.12l1.144-2.318a.216.216 0 0 1 .29-.097l-.06-.124a.22.22 0 0 0-.394 0l-1.144 2.318a.22.22 0 0 1-.165.12l-2.558.372a.22.22 0 0 0-.122.374l.103.1a.22.22 0 0 1 .183-.254"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__y)",
    d: "m45.954 66.592 1.144 2.318a.22.22 0 0 0 .165.12l2.558.372a.22.22 0 0 1 .122.374l-1.851 1.804a.22.22 0 0 0-.063.194l.437 2.548a.22.22 0 0 1-.318.231l-2.288-1.202a.22.22 0 0 0-.205 0l-2.288 1.202a.22.22 0 0 1-.318-.23l.437-2.549a.22.22 0 0 0-.063-.194l-1.851-1.804a.22.22 0 0 1 .121-.374l2.558-.372a.22.22 0 0 0 .166-.12l1.144-2.318a.22.22 0 0 1 .393 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brand-einbruchschutz_svg__z)",
    d: "M45.757 66.47a.22.22 0 0 1 .197.122l1.144 2.318a.22.22 0 0 0 .165.12l2.558.372a.22.22 0 0 1 .122.374l-1.851 1.804a.22.22 0 0 0-.063.194l.437 2.548a.219.219 0 0 1-.319.231l-2.288-1.202a.22.22 0 0 0-.204 0l-2.288 1.202a.219.219 0 0 1-.318-.23l.437-2.549a.22.22 0 0 0-.063-.194l-1.851-1.804a.22.22 0 0 1 .121-.374l2.558-.372a.22.22 0 0 0 .166-.12l1.144-2.318a.22.22 0 0 1 .196-.122m0-.228a.44.44 0 0 0-.4.25l-1.144 2.317-2.552.368a.447.447 0 0 0-.248.762l1.851 1.804-.439 2.54a.446.446 0 0 0 .648.472l2.288-1.203 2.28 1.203a.447.447 0 0 0 .649-.471l-.437-2.548 1.849-1.797a.447.447 0 0 0-.248-.762l-2.558-.372-1.138-2.314a.44.44 0 0 0-.4-.249",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2c756",
    d: "m43.213 74.543.437-2.548a.22.22 0 0 0-.063-.194l-.107-.104a.2.2 0 0 1 .006.077l-.437 2.548a.215.215 0 0 0 .167.245c0-.009-.005-.015-.003-.024M47.262 69.13a.22.22 0 0 0 .165.12l2.558.372c.007.001.01.007.017.008a.214.214 0 0 0-.18-.228l-2.559-.372a.2.2 0 0 1-.064-.026ZM41.857 69.622l2.558-.371a.22.22 0 0 0 .165-.12l1.144-2.318a.216.216 0 0 1 .291-.097l-.06-.124a.22.22 0 0 0-.394 0l-1.144 2.318a.22.22 0 0 1-.166.12l-2.558.372a.22.22 0 0 0-.121.374l.103.1a.22.22 0 0 1 .182-.254"
  }))));
};
export default SvgPremiumBrandEinbruchschutz;